
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/glossary/[term]",
      function () {
        return require("private-next-pages/learn/glossary/[term].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/glossary/[term]"])
      });
    }
  